(() => {
  const MIN_INTERVAL_MS = 12000;
  const MAX_INTERVAL_MS = 22000;

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function formatTemplate(template, count) {
    return template.replace(/\{\{\s*count\s*\}\}/g, String(count));
  }

  function updateViewers(el) {
    const min = Number(el.dataset.min) || 1;
    const max = Number(el.dataset.max) || 5;
    const previous = Number(el.dataset.current) || 0;
    let count = randomInt(min, max);

    // Avoid showing the same number twice in a row when possible.
    if (max > min && count === previous) {
      count = count === max ? min : count + 1;
    }

    el.dataset.current = String(count);
    const template = count === 1 ? el.dataset.templateOne : el.dataset.templateOther;
    const textTarget = el.querySelector('[data-viewers-text]') || el;
    textTarget.textContent = formatTemplate(template || '', count);
  }

  function scheduleNext(el) {
    const delay = randomInt(MIN_INTERVAL_MS, MAX_INTERVAL_MS);
    el._viewersTimer = window.setTimeout(() => {
      if (document.hidden) {
        scheduleNext(el);
        return;
      }
      updateViewers(el);
      scheduleNext(el);
    }, delay);
  }

  function init(el) {
    if (el.dataset.viewersReady === 'true') return;
    el.dataset.viewersReady = 'true';
    updateViewers(el);
    scheduleNext(el);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-minico-viewers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
